import{getPrAppUrls as r}from"../../storage/getPrAppUrls/getPrAppUrls.js";var e=function(e){var p=(void 0===e?{}:e)._dependencies,o=(void 0===p?{}:p).getPrAppUrls,t=(void 0===o?r:o)();return t?JSON.parse(t):{}};export{e as fetchSessionPrAppUrls};
//# sourceMappingURL=fetchSessionPrAppUrls.js.map
